/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MailerRegularAi from './mailer-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MailerRegularAi {...validProps} />;
}
SvgComponent.iconName = 'mailerRegularAi';

export const MailerRegularAiIcon = svgIconWrapper(SvgComponent);
